<template>
<div>
    <div class="col-12 pb-5 mb-4" v-if="trackApplicationLoader">
        <img src="../assets/pageloader.svg" class="pageloader" alt="loadinganimation">
    </div>
    <div class="row no-gutters body" v-else>
        <div class="col-lg-3 middle-background"></div>
        <div class="col-md-12 col-lg-6 middle-background pb-4" >
            <div class="row no-gutters">
                <br />
            </div>
            <div class="row no-gutters mt-5" v-if="!currentUserProfileId && currentUserProfileId === undefined" >
                <div class="col-lg-12 pb-3">
                <div class="row no-gutters">
                    <br />
                </div>
                <div class="ml-3 mr-3 mt-lg-2 main-card">
                </div>
                </div>
            </div>
            <div class=" no-gutters mt-5 main-card" v-else>
                <div class="col-lg-12"> 
                    <div class="row no-gutters">
                        <br />
                    </div> 
                        <div>
                            <div class="fontsize18 black proximanova-semibold pl-3 my-auto pointer" @click="previous"><img src="../assets/Back.svg" class="img-fluid mr-1 my-auto pointer" alt="back" /> Support Center</div>
                        <div class="pb-5">
                            <div class="shadow card mb-2 ml-3 mr-3 mt-lg-3" >
                                <div class="card-body homevideoslist">
                                    <div class="d-flex p-4 col-md-6 mx-auto">
                                        <div class="d-flex">
                                            <input type="radio" id="reportIssue" class="ml-3 my-auto"  v-model="reportissue" v-bind:value="'reportIssue'" name="radio" checked  @click="resetEntries()"> 
                                            <label :for="'reportIssue'" class="fontsize16 pointer black proximanova-semibold labels text-nowrap my-auto ml-2">Report Issue</label>
                                        </div>
                                        <div class="d-flex">
                                            <input type="radio" class="ml-3 my-auto" id="checkstatus"  v-model="reportissue" v-bind:value="'checkstatus'" name="radio" @click="resetEntries()">  
                                            <label :for="'checkstatus'" class="fontsize16 pointer black proximanova-semibold my-auto text-nowrap labels ml-2">Check Status</label>
                                        </div>
                                    </div>
                                    <center class="pl-3 pr-3 pb-3"><span :style="msgcolor" class="fontsize14 proximanova"><b>{{information}}</b></span></center>
                                    <div v-if ="reportissue === reportIssue" class="pl-3 pr-2">
                                        <div class="row no-gutters mb-3 mt-3">
                                            <div class="col d-flex justify-content-start align-items-center ml-md-2">
                                                <div class="col-6">
                                                    <div class="input-group">
                                                        <input
                                                        type="text"
                                                        v-validate=" 'required' "
                                                        name="Title"
                                                        data-vv-as="Title"
                                                        class="input-create"
                                                        v-model.trim="report.title"
                                                        autocomplete="nope"
                                                        required
                                                        />
                                                        <span class="bar"></span>
                                                        <label class="label-create required">Report Title</label>
                                                    </div>
                                                </div>
                                                <div class="col-6">
                                                    <div class="input-group">
                                                        <select v-model="report.severity" v-validate="'required'" name="Severity" class="input-create fontsize12px proximanova black" data-vv-as="Severity">
                                                            <option  value="" disabled>Select</option>
                                                            <option v-for="(severity, index) in saveritiesList" :key="index" :value="severity.indexDetailName">{{severity.indexDetailName}}</option>
                                                        </select>
                                                        <span class="bar"></span>
                                                        <label class="label-create required">Severity</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col d-flex ml-2">
                                                <div class="col-6 pl-0 pr-0"><div v-if="errors.has('Title')" class="alert-danger ml-3" > {{ errors.first('Title') }} </div></div>
                                                <div class="col-6 pl-0 pr-0"><div v-if="errors.has('Severity')" class="alert-danger ml-3" > {{ errors.first('Severity') }} </div></div>
                                            </div>
                                        </div>
                                        <div class="row no-gutters mt-4">
                                            <div class="col d-flex justify-content-start align-items-center ml-md-2">
                                                <div class="col-6">
                                                    <div class="input-group">
                                                        <small class="required small-label">Screen Name</small>
                                                        <multiselect 
                                                            style="width:100%"
                                                            v-validate="'required'" 
                                                            class="multiselect multiselectInput-create proximanova"
                                                            name="screenName"
                                                            data-vv-as="screenName" 
                                                            v-model="report.screenName"        
                                                            :options="userScreensList" 
                                                            v-bind:value="userScreensList.indexDetailName" 
                                                            v-bind:key="userScreensList.indexDetailName"
                                                            :custom-label="customLabel">     
                                                        </multiselect>
                                                        <span class="bar"></span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col d-flex mb-3">
                                            <div v-if="errors.has('screenName')" class="alert-danger ml-3" > {{ errors.first('screenName') }} </div>
                                        </div>
                                        <div class="row no-gutters ml-2 ml-md-4">
                                            <div class="col d-flex justify-content-start align-items-center ">
                                                <div class="form-group">
                                                    <label for="exampleFormControlTextarea1" class="proximanova">Issue Description <div class="d-flex">(<p id="charactersRemaining">400</p><p>/400 )</p></div></label>
                                                    <textarea
                                                        class="form-control proximanova"
                                                        v-model="report.incDesc"
                                                        id="exampleFormControlTextarea1"
                                                        @keyup="textareaCharacterCount()"
                                                        rows="5"
                                                        cols="77"
                                                        spellcheck="true"
                                                        maxlength="400"
                                                    ></textarea>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="p-4">
                                            <div class="col-md-4 mx-auto d-flex justify-content-around">
                                            <center><button  class="btn proximanova black border borderradius20" @click="resetFeedBackFrom">Clear</button></center>
                                            <center v-if="submitBtnCicked"><img src="../assets/uploadvideo.svg" width="30px" class="img-fluid ml-1" alt="uploadvideo"></center>
                                            <center v-else><button  class="btn btn-secondary opacity1 borderradius20 backgroundcolorblack proximanova sign-up-button" @click="savefeedback">Submit</button></center>
                                                </div>
                                        </div>
                                    </div>
                                    <div v-if="reportissue === checkstatus" >
                                        <div v-if="loadingIssuesList">
                                            <img src="../assets/loadingIcon1.gif" class="pageloader mx-auto" width="40px" alt="loading">
                                        </div>
                                        <div v-else>
                                            <div class="experience" v-for="(report, index) in issuesList" :key="index">
                                                <div class="exp pl-3 pr-3 mt-1 mb-2">
                                                    <div class="col-12 border p-2 borderadius12 experiences pl-0">
                                                        <div class="d-flex justify-content-between">
                                                            <div class="col-10 d-flex">
                                                                <div class="">
                                                                    <img src="../assets/PrivacySettings.svg" alt="settings" width="25px" class=" mt-0 rounded-circle">
                                                                </div>
                                                                <div class="flex-nowrap ml-2 proximanova fontsize14 black80 text-capitalize">
                                                                    <div class="flex-nowrap proximanova-bold fontsize14 black text-capitalize"> 
                                                                        <span title="report title"> Case ID : {{report.siId}}</span>
                                                                        <span title="report severity" class="ml-5 backgroundcolor5 borderadius12 p-1 pl-2 pr-2 borderred proximanova red">{{report.severity}}</span>
                                                                    </div>
                                                                    <div class="mt-1 flex-nowrap proximanova-semibold fontsize14 black text-capitalize">{{report.title}} <span class="proximanova black60 fontsize12">, {{new Date(report.createdAt) | moment("from", "now", true)}} ago</span></div>
                                                                    <!-- <div class="proximanova black60 fontsize14">{{report.createdAt| moment("MM/DD/YYYY")}}</div> -->
                                                                    <!-- <div title="creation date" class="proximanova black60 fontsize12">{{new Date(report.createdAt) | moment("from", "now", true)}} ago</div> -->
                                                                    <div title="mt-1 report description" class="proximanova black80 fontsize14">{{report.incDesc}}</div>
                                                                </div>
                                                            </div>
                                                            <div class="d-flex mr-lg-2 mr-sm-1 justify-content-between">
                                                                <div class="d-flex mr-lg-2 mr-sm-1 pointer" @click="updateReportIssue(index)">
                                                                    <img src="../assets/Edit.svg" alt="edit" style="width:26px">
                                                                    <div class="ml-1 d-none d-lg-block my-auto fontsize14 proximanova" style="vertical-align:middle">Edit</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-if="issuesList.length < 1">
                                                <center class="pl-3 pr-3 pb-3"><span class="fontsize14 red proximanova"><b>No reports Found</b></span></center>
                                            </div>
                                            <br><br>
                                            <div v-if="report.siId!=''">
                                                <div class="row no-gutters mb-3 mt-3 pl-2 pr-2">
                                                    <div class="col-12 d-flex justify-content-start align-items-center">
                                                        <div class="col-6">
                                                            <div class="input-group">
                                                                <small class="required small-label">Report Title</small>
                                                                <input
                                                                type="text"
                                                                v-validate=" 'required' "
                                                                name="Title"
                                                                data-vv-as="Title"
                                                                class="input-create"
                                                                v-model.trim="report.title"
                                                                autocomplete="nope"
                                                                required
                                                                />
                                                                <span class="bar"></span>
                                                            </div>
                                                        </div>
                                                        <div class="col-6">
                                                            <div class="input-group">
                                                                <small class="required small-label">Severity</small>
                                                                <select v-model="report.severity" v-validate="'required'" name="Severity" class="input-create fontsize12px proximanova black" data-vv-as="Severity">
                                                                    <option  value="" disabled>Select</option>
                                                                    <option v-for="(severity, index) in saveritiesList" :key="index" :value="severity.indexDetailName">{{severity.indexDetailName}}</option>
                                                                </select>
                                                                <span class="bar"></span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col d-flex ml-2">
                                                        <div class="col-6 pl-0 pr-0"><div v-if="errors.has('Title')" class="alert-danger ml-3" > {{ errors.first('Title') }} </div></div>
                                                        <div class="col-6 pl-0 pr-0"><div v-if="errors.has('Severity')" class="alert-danger ml-3" > {{ errors.first('Severity') }} </div></div>
                                                    </div>
                                                </div>
                                                <div class="row no-gutters mt-4 pl-2 pr-2">
                                                    <div class="col-12 d-flex justify-content-start align-items-center">
                                                        <div class="col-6">
                                                            <div class="input-group">
                                                                <small class="required mb-2 small-label">Screen Name</small>
                                                                <multiselect 
                                                                    style="width:100%"
                                                                    v-validate="'required'" 
                                                                    class="multiselect multiselectInput-create proximanova"
                                                                    name="screenName"
                                                                    data-vv-as="screenName" 
                                                                    v-model="report.screenName"        
                                                                    :options="userScreensList" 
                                                                    v-bind:value="userScreensList.indexDetailName" 
                                                                    v-bind:key="userScreensList.indexDetailName"
                                                                    :custom-label="customLabel">     
                                                                </multiselect>
                                                                <span class="bar"></span>
                                                            </div>
                                                        </div>
                                                        <div class="col-6 mt-3">
                                                            <div class="input-group">
                                                                <small class="proximanova-semibold black60 fontsize14">Case status</small>
                                                                <select  :disabled="userEmail !== 'jagadeesh.bukta@syntrino.net'" class="input-create fontsize12px proximanova black" v-model.trim="report.caseStatus" >
                                                                    <option disabled  :value='null' > Select Status </option>
                                                                    <option selected v-for="status in caseStatusList" v-bind:value="status.id" v-bind:key="status.id" > {{ status.indexDetailName}} </option>
                                                                </select>
                                                                <span class="bar"></span>
                                                                <!-- <label class="label-create required">Case status</label> -->
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col d-flex mb-3">
                                                    <div class="col-6 pl-0 pr-0"><div v-if="errors.has('screenName')" class="alert-danger ml-3" > {{ errors.first('screenName') }} </div></div>
                                                    <div class="col-6 pl-0 pr-0"><div v-if="errors.has('case status')" class="alert-danger"> {{ errors.first('case status') }} </div></div>
                                                </div>
                                                <div class="row no-gutters ml-4">
                                                    <div class="col-12 d-flex justify-content-start align-items-center ">
                                                        <div class="form-group col-12 pl-0">
                                                            <label for="exampleFormControlTextarea1" class="proximanova">Issue Description <div class="d-flex">(<p id="charactersRemaining">400</p><p>/400 )</p></div></label>
                                                            <textarea
                                                                class="form-control proximanova"
                                                                style="width:100%"
                                                                v-model="report.incDesc"
                                                                id="exampleFormControlTextarea1"
                                                                @keyup="textareaCharacterCount()"
                                                                rows="5"
                                                                cols="77"
                                                                spellcheck="true"
                                                                maxlength="400"
                                                            ></textarea>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="p-4">
                                                    <div class="col-md-4 mx-auto d-flex justify-content-around">
                                                    <center><button  class="btn proximanova black border borderradius20" @click="resetFeedBackFrom">Clear</button></center>
                                                    <center v-if="submitBtnCicked"><img src="../assets/uploadvideo.svg" width="30px" alt="uploading" class="img-fluid ml-1"></center>
                                                    <center v-else><button  class="btn btn-secondary opacity1 borderradius20 backgroundcolorblack proximanova sign-up-button" @click="saveissuedata">Submit</button></center>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col middle-background">
          <div class="row no-gutters">
            <br />
          </div>
          <div class="row no-gutters">
            <br />
          </div>
        </div>
        <APIerrorModal v-if="displayAPIerrorModal" @closeAPIerrorModal="closeAPIerrorModal"></APIerrorModal>
    </div>
</div>
</template>
<script>
import httpreport from "@/js/http-report.js";
import APIerrorModal from '../components/APIerrorpopup.vue'
import sessionUtils from '@/js/session-util.js'
import htttpuserprofile from "@/js/http-userprofile.js";
import { bus } from "../main";
export default{
    components : {
        APIerrorModal
    },
    data(){
    return{
        currentUserProfileId : null,
        displayAPIerrorModal : false,
        trackApplicationLoader : false,
        image : '',
        reportissue:'reportIssue',
        reportIssue:'reportIssue',
        checkstatus:'checkstatus',
        submitBtnCicked : false,
        loadingIssuesList : false,
        selectedissue:'',
        issuesList:[],
        developerIssuesList : [],
        userType : null,
        msgcolor: {
            color: 'black'
        },
        information:'',
        caseStatusList : [],
        saveritiesList : [],
        userScreensList : [],
        report:this.reporteddata(),
        userEmail : sessionUtils.getCompanyEmail()
    }
    },
    methods:{
        previous(){
            this.$router.go(-1);
        },
        fetchDropdownData : function() {
            //fetching user screens list
            htttpuserprofile.get("searchController/getIndexDetailsList", {
                params: { indexCode: 20 }
            }).then(response => {
                this.userScreensList = response.data;
                console.log(response.data);
            });
            //fetching severities list 
            htttpuserprofile.get("searchController/getIndexDetailsList", {
                params: { indexCode: 21 }
            }).then(response => {
                this.saveritiesList = response.data;
                console.log(response.data);
            });
            //fetch case status list
            htttpuserprofile.get("searchController/getIndexDetailsList", {
                params: { indexCode: 22 }
            }).then(response => {
                this.caseStatusList = response.data;
                console.log(response.data);
            });
            //fetch inctype user
            htttpuserprofile.get("searchController/getIndexDetailsList", {
                params: { indexCode: 25 }
            }).then(response => {
                this.userType = response.data;
                console.log(response.data);
            });
        },
        closeAPIerrorModal(){
            this.displayAPIerrorModal = false;
        },
        textareaCharacterCount() {
            var textEntered, countRemaining, counter;
            textEntered = document.getElementById('exampleFormControlTextarea1').value;
            counter = (400 - (textEntered.length));
            countRemaining = document.getElementById('charactersRemaining');
            countRemaining.textContent = counter;
        },
        reporteddata(){
            return{
                image:'',
                caseStatus:'',
                createdAt:'',
                creationUserI:'',
                employeeId:'',
                siId:'',
                incDesc:'',
                lastUpdatedAt:'',
                lastUpdatedUserI:'',
                screenName:'',
                severity:'',
                title:'',
            }
        },
        setDescriptionLength() {
            var textEntered, countRemaining, counter;
            textEntered = document.getElementById('exampleFormControlTextarea1').value;
            counter = (400 - (textEntered.length));
            countRemaining = document.getElementById('charactersRemaining');
            countRemaining.textContent = counter;
            this.submitBtnCicked = false;
        },
        customLabel (option) {
            return `${option.indexDetailName}`
        },
        resetFeedBackFrom() {
            this.submitBtnCicked = false;
            this.report = this.reporteddata()
        },
        savefeedback:function(){
            this.$validator.validateAll().then(() => {
                if (!this.errors.any()) {
                    this.submitBtnCicked = true;
                    // let schactivityPayload = {
                    //     "userId": sessionUtils.getBusinessAccountId(),
                    //     "title":  this.report.title,
                    //     "severity": this.report.severity,
                    //     "screenName": this.report.screenName.indexDetailName,
                    //     //"image": this.report.image,
                    //     "incDesc":this.report.incDesc,
                    //     "creationUserI":sessionUtils.getCompanyEmail(),
                    //     "lastUpdatedUserI": sessionUtils.getCompanyEmail(),
                    //     "caseStatus":this.report.caseStatus,
                    // }
                    let schactivityPayload = {
                        "loggedInUser": sessionUtils.getBusinessAccountId(),
                        "title":  this.report.title,
                        "severity": this.report.severity,
                        "screenName": this.report.screenName.indexDetailName,
                        //"image": this.report.image,
                        "incDesc":this.report.incDesc,
                        "creationUserI":sessionUtils.getCompanyEmail(),
                        "lastUpdatedUserI": sessionUtils.getCompanyEmail(),
                        "caseStatus":this.report.caseStatus,
                        "reportType": "Job"
                    }
                    console.log("severity : ", schactivityPayload)
                    httpreport.post('/reporting/support',schactivityPayload).then(response => {
                        console.log("added report : ", response)
                        var status = response.data;
                        this.submitBtnCicked = false;
                        if (status == 'CREATED') {
                            this.information = 'Issue was reported Successfully. Support Team would respond 24 to 48 business hours. If any further questions please contact at support@worknotion.com '
                            this.msgcolor.color = 'Blue'
                            this.report=this.reporteddata()
                            this.setDescriptionLength()
                            console.log(JSON.stringify(status))
                        } else {
                            this.msgcolor.color = 'Red'
                            this.information = ''
                        }
                    }).catch(e => {
                        this.msgcolor.color = 'Red'
                        this.submitBtnCicked = false;
                        this.displayAPIerrorModal = true;
                        this.information = '' || e.name || e.message
                    })
                }else{
                    this.submitBtnCicked = false;
                }
            })
        },
        getreportissues(){  
                httpreport.get('/reporting/readIssues/'+ sessionUtils.getBusinessAccountId()+'?reportType=Job&loggedInUserEmailId='+sessionUtils.getCompanyEmail()+'&fromDate=&toDate=&caseStatus=&applyFilters=N').then(response => {   
                    this.issuesList = [];
                    let responsedata = response.data;
                    if(responsedata && responsedata.length > 0){
                        for(var i =0; i < responsedata.length; i++){
                            this.issuesList.push(responsedata[i].supportInc)
                        }
                    }
                    // this.issuesList = response.data[0]
                    console.log(this.issuesList)
                    this.loadingIssuesList = false;
                }).catch((e) => {
                    console.log(e)
                    this.loadingIssuesList = false;
                })
        },
        updateReportIssue(index){
            //this.getreportissues()
            var record = this.issuesList[index]
            var screenName = record.screenName;
            var screenNameObj;
            if(typeof(screenName) == "string"){
                screenNameObj = {
                    "key" : screenName,
                    "indexDetailName" : screenName
                }
            }else{
                screenNameObj = screenName
            }
            console.log(screenNameObj)
            record.screenName = screenNameObj
            this.report = record;
            console.log(this.report)
        },
        saveissuedata(){
            this.$validator.validateAll().then(() => {
                if (!this.errors.any()) {
                    this.submitBtnCicked = true;
                    let updatepayload = this.report;
                    updatepayload.screenName = this.report.screenName.key;
                    if(updatepayload.developerEmail == null || updatepayload.developerEmail == ''){
                    updatepayload.developerEmail = ''
                    }
                    console.log("updated report : ", updatepayload)
                    httpreport.put('/reporting/updateissue/'+sessionUtils.getBusinessAccountId()+'/'+this.report.siId, updatepayload).then(response => {
                        var status = response.data
                        this.submitBtnCicked = false;
                        if (status == 'ACCEPTED') {
                            this.information = 'Issue Edited  Successfully'
                            this.msgcolor.color = 'Blue'   
                            this.getreportissues();   
                            this.report= this.reporteddata() 
                            this.setDescriptionLength()  
                            this.selectedissue=''         
                        } else {
                            this.msgcolor.color = 'Red'
                            this.information = ''            
                            this.getreportissues();   
                            this.report= this.reporteddata()      
                            this.selectedissue=''     
                        }
                    }).catch(e => {
                        this.msgcolor.color = 'Red'
                        this.submitBtnCicked = false;
                        this.displayAPIerrorModal = true;
                        this.information = '' || e.name || e.message       
                        this.getreportissues();        
                        this.report= this.reporteddata()   
                        this.selectedissue=''            
                    })
                }else{
                    this.submitBtnCicked = false;
                    console.log("error")
                }
            })  
        },
        resetEntries(){
            this.loadingIssuesList = true;
            this.getreportissues()
            this.report=this.reporteddata()
            this.selectedissue=''
            this.information=''
        },
        onFileChange(e) {
            var files = e.target.files || e.dataTransfer.files;
            if (!files.length)
            return;
            this.createImage(files[0]);
        },
        createImage(file) {
            var image = new Image();
            var reader = new FileReader();
            var vm = this;
    
            reader.onload = (e) => {
            vm.image = e.target.result;
            };
            reader.readAsDataURL(file);
        },
       removeImage: function (e) {
         this.image = '';
       }
    },
    computed:{
        sortedIssues:function(){     
         return this.issuesList.sort((a, b) => { return a.caseStatus > b.caseStatus? 1:-1 ;});
       }
     },
    mounted(){
        this.currentUserProfileId = sessionUtils.getCompanyProfileId();
        this.fetchDropdownData()
    },
    beforeDestroy(){
    }
}
</script>
<style scoped>
@import '../css/vue-multiselect.min.css';
#search{
    background-color: white
}
#searchedInput{
    background-color: white !important;
}
#basic-text{
    background-color: white !important;
    border-radius: 10px 0px 0px 10px;
}
.multiselect__content-wrapper{
    max-height: 200px !important;
}
.loadingBgImg{
  background: transparent url('../assets/loading_gif1.gif') center no-repeat;
  background-size: 30px 30px;
}
.card {
  border: 1px solid #dddfe5;
  border-radius: 10px;
  background-color: #ffffff;
}
.mobileview{
    overflow: auto;
}   
/* Hide scrollbar for Chrome, Safari and Opera */
.mobileview::-webkit-scrollbar {
    display: none;
}

.card-header1 {
  border: 1px solid #d9dce1;
  opacity: 1;
  border-radius: 8px;
}  
.pageloader {
  width: 7%;
  margin-top: 5% !important;
  margin-left: 46% !important;
  padding-bottom: 10% !important;
} 
.instanceloader{
  width: 10%;
  margin-left: 46%;
}
.list-group-item{
    padding: .25rem 0.25rem;
    border: none;
    border-radius: 5px;
}
.list-group-item:hover{
    background: rgba(31,31,31,.1);
}
#locationtext{
    border-radius: 10px 0 0 10px;
}
.imgborder1 {
  padding: 10px 15px 10px 10px;
  background-color: rgba(161, 166, 179,0.1);
  border-radius: 0px 10px 10px 0px;
}
.main-badge {
    background: linear-gradient(44.51deg, #E6784F 0%, #EA5184 100%) !important;
    font-size: 12px !important;
    /* opacity: 30%; */
}
.input-group-append{
  margin-left: 0 !important;
}
.mobviewItems {
    /* font-size: 10px  !important; */
    overflow-x: auto !important;
  }
  .mobviewItems::-webkit-scrollbar {
    display: none;
}
.sign-up-button{
    opacity: 1 !important;
    background: black !important;
}
.card-header {
  padding: 5px 10px 5px 10px;
  margin-bottom: 0;
  border: 1px solid #d9dce1;
  opacity: 1;
  border-radius: 8px !important;
  background-color: #f0f2f5;
}
.nav-tabs {
  border-bottom: none !important;
}
#filterDropdown{
  left : unset !important;
  z-index: 3;
  width: 320px !important;
  cursor: pointer;
}
.navtoPage{
    cursor: pointer;
}
#dropdown{
    min-width: 100%;
    margin-top: 5px;
}
.dropdown-menu{
  cursor: pointer;
  position: absolute;
  display:block;    
  color: black;
  box-shadow: 0px 8px 16px 0px rgba(0,23,56,0.1);
  border: none;
  margin-top: 0px;   
  border-radius: 10px  !important;
}
.nameBlock:hover{
	color:#007AFF !important;
	text-decoration: underline;
	white-space: nowrap;
	}
.closebtnmouseover {
    border: 1px solid white;
}
.closebtnmouseover:hover {

  background-color: rgba(161, 166, 179,0.1);
  border-radius: 60%;
  border: 1px solid rgba(161, 166, 179,.5);
}
.multiselectInput-create {
  font-size: 18px;
  padding: 0 0 0 0;
  display: block;
  width: 100%;
  border: none;
  font-family: "ProximaNova-Regular" !important;
  /* border-bottom: 1px solid #757575; */
}
.input-create {
  font-size: 18px;
  padding: 10px 10px 10px 5px;
  display: block;
  width: 100%;
  border: none;
  border-bottom: 1px solid #757575;
  font-family: "ProximaNova-Regular" !important;
}
.input-create:focus{
/* .input-create:valid { */
  outline: none;
  border-bottom: 1px solid #0078FF;
}
.multiselectInput-create:hover {
  border-bottom: 1px solid #0078FF !important;
}

/* LABEL ======================================= */
.label-create {
  color: #999;
  font-size: 14px;
  font-weight: normal;
  position: absolute;
  pointer-events: none;
  left: 5px;
  top: 20px;
  font-family: "ProximaNova-Regular" !important;
  transition: 0.2s ease all;
  -moz-transition: 0.2s ease all;
  -webkit-transition: 0.2s ease all;
}

/* active state */
.input-create:focus ~ .label-create,
.input-create:valid ~ .label-create {
  top: -15px;
  font-size: 14px;
  /* color: #0078FF; */
}
.form-control {
    border-radius: 10px;
  background-color: white !important;
  border: 1px solid #ced4da !important;
  /* border-radius: 0px 10px 10px 0px !important; */
}
.activeVideoSub {
  background-color: #d6e9ff;
  border: 1px solid #9ecbff;
  color: #0078ff;
}
.btn-color{
  border-color: rgba(31, 31, 31,0.1);
}
.form-control:focus{
    outline: none !important;
    box-shadow: none !important;   
    border-radius: 10px;
    background-color: rgba(161, 166, 179,0.1);
    border: #DDDFE5;   
}

.sign-in-button{
  font-family: "Proxima Nova";
  font-size: 16px;
  font-weight: 600;
  color: #1F1F1F;
  opacity: 30%;
  transition : ease-out 0.3s;
  POSITION : relative;
  z-index : 1
}
.sign-in-button::before {
  transition : 0.5s all ease;
  position : absolute;
  top : 0;
  left : 30%;
  right : 30%;
  bottom : 0;
  opacity : 0;
  content : "";
  background-color :  rgba(255,255,255,.3);
}
.sign-in-button:hover:before {
  transition : 0.5s all ease;
  left : 0;
  right : 0;
  opacity : 1;
  z-index : -1
}

.card-body{
    padding:0 !important;
}
.card-footer{
    background-color: rgba(161, 166, 179,0.1);
    padding: unset !important;
}
.rejStatus{
     background-color: rgba(161, 166, 179,0.1);
     border-radius: 10px;
}
.statusImg{
    vertical-align: baseline;
    width: 20px;
    height: 20px;
}
.jobProfImg{
    width: 56px;
    height: 56px;
}
.activeSub {
  background-color: #d6e9ff;
  border: 1px solid #9ecbff;
  color: #0078ff;
}
.pillbtn {
  cursor: pointer;
  border: 1px solid #dbdbdb;
  border-radius: 16px;
  padding-left: 8px !important;
  padding-right: 9px !important;
}
.nobtn{
    color: black;
}
@media screen and (max-width: 1020px) and (min-width: 767px) {
  .main-card {
    padding-left: 5%;
    padding-right: 5%;
  }
}
@media screen and (min-width: 550px) and (max-width : 768px){
    .jobProfImg {
        height: 50px;
    }
}
@media screen and (max-width : 550px) {
    .jobProfImg{
        height: 47px;
    }
}
</style>
